export class DeleteProfilePictureSuccess {
    static readonly type = '[User] DeleteProfilePictureSuccess';
}
